import { createContext } from "react";

import { LoginAuthType, MuiPaletteType } from "@ryde/shared";

interface ILoginPageFormContext {
  buttonLoginColor: MuiPaletteType;
  isNonProductionLoginColors: boolean;
  loginTypeWatchedValue:
    LoginAuthType.Username | LoginAuthType.Phone | LoginAuthType.Email;
  handleSubmit: () => Promise<void>;
}

export const LoginPageFormContext = createContext<ILoginPageFormContext>({
  buttonLoginColor: "primary",
  isNonProductionLoginColors: false,
  loginTypeWatchedValue: LoginAuthType.Username,
  handleSubmit: async (): Promise<void> => {
    return;
  },
});
